import { Suspense } from "react";
import { IconLayoutGrid } from "@tabler/icons-react";
import { Alert, Group, Heading, Stack, Tabs, TabsContent, TabsList, TabsTrigger, Text } from "@/components/ui";
import { ModulosPanelSkeleton } from "./ModulosSkeleton";
import { ModulosPorRolPanel } from "./ModulosPorRolPanel";
import { ModulosPorUsuarioPanel } from "./ModulosPorUsuarioPanel";

/**
 * Gestor de módulos (`/admin/modulos`). Un «módulo» = una capacidad/pantalla del portal
 * (un permiso del catálogo). Dos vistas:
 *  · Por rol · habilita/deshabilita módulos a cada rol (incluidos los de sistema, editables).
 *  · Por usuario · overrides puntuales: otorgar un módulo extra o bloquear uno heredado.
 * El backend hace el enforcement real; el módulo aplica al instante en el servidor y en la UI
 * de cada usuario tras su próximo inicio de sesión.
 */
export function AdminModulosPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-8 md:px-6">
      <Stack gap="md">
        <Group>
          <Heading order={2} className="flex items-center gap-2">
            <IconLayoutGrid size={22} className="text-multiva-600" />
            Gestor de módulos
          </Heading>
        </Group>
        <Alert variant="info" title="Cómo funcionan los módulos">
          <Text size="sm">
            Un <b>módulo</b> es una capacidad del portal (una pantalla o acción). Asígnalos <b>por rol</b>
            {" "}(todos los usuarios de ese rol lo reciben) o haz ajustes <b>por usuario</b>: <b>otorgar</b> un
            módulo extra a alguien, o <b>bloquearle</b> uno que su rol sí le daría. El bloqueo por usuario
            gana. Los cambios aplican al instante en el servidor; en la sesión de cada usuario, tras su próximo
            inicio de sesión.
          </Text>
        </Alert>

        <Tabs defaultValue="rol">
          <TabsList className="mb-4">
            <TabsTrigger value="rol">Por rol</TabsTrigger>
            <TabsTrigger value="usuario">Por usuario</TabsTrigger>
          </TabsList>
          <TabsContent value="rol">
            <Suspense fallback={<ModulosPanelSkeleton />}>
              <ModulosPorRolPanel />
            </Suspense>
          </TabsContent>
          <TabsContent value="usuario">
            <Suspense fallback={<ModulosPanelSkeleton />}>
              <ModulosPorUsuarioPanel />
            </Suspense>
          </TabsContent>
        </Tabs>
      </Stack>
    </div>
  );
}

